
<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="19"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="场次号">
							<c-input name="auction_batch_no"></c-input>
						</m-search-item>
						<m-search-item label="出价渠道">
							<c-select name="channel_id" async @search="searchChannel"></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_bid_list_export')" prepend-icon="tf-export" @click="exportBidList()">导出</c-button>
				</template>

				<template #product_info="{data}">
					<m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
				</template>

				<template #produce_unique_code="{data}">
					{{data.produce_unique_code}} <c-link color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #produce_imei="{data}">
					{{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #cost_price="{data}">
					{{formatPrice(data.cost_price)}}
				</template>

				<template #bid_amount="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.bid_amount)}}</span>
				</template>

				<template #bid_state="{data}">
					<c-state dict="BID_STATE" :value="data.bid_state"></c-state>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import CState from "@/components/public/state.vue";

    export default {
        components: {CState},
		methods: {
			/*********搜索出价渠道**********/
			searchChannel(keyword, resolve) {
				this.request({
					url: '/sale/product/channel/options',
					data: {
						keyword: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.channel_name,
								value: item.channel_id
							};
						}));
					}
				});
			},

			/*********导出出价列表**********/
			exportBidList() {
				var search = this.$refs.search ? this.$refs.search.get() : {};
				//选中行导出：取勾选行主键随导出参数上传，未勾选为空数组即全量
				var listRef = this.$refs.view && this.$refs.view.$refs.list;
				var ids = (listRef && listRef.getRow('selected') || []).map(item => (item.data || item).id);
				this.request({
					url: '/sale/bid/export/url',
					data: Object.assign({
						view_id: this.$refs.view.getViewId(),
						ids: ids
					}, search),
					success: data => {
						if (data && data.url) {
							//后端返回相对路径，须走全局 download 拼 baseUrl 取流；window.open 会落到前端域渲染成商家端页面
							this.download({
								fileName: data.filename,
								url: data.url,
								loading: {
									message: '正在导出出价列表...'
								}
							});
						}
					}
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********批量删除出价记录**********/
			batchDelete(list) {
				var validList = list.filter(item => item.bid_state != 2);
				if (!validList.length) {
					this.$message({message: '竞价成功的记录不可删除', type: 'warn'});
					return;
				}
				this.deleteBid(validList);
			},

			/*********删除出价记录**********/
			deleteBid(list) {
				if (!list.length) return;
				this.$confirm({
					message: '确认删除所选的' + list.length + '条出价记录吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/sale/bid/delete',
							data: {
								bid_ids: list.map(item => item.id)
							},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg, type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}
	}
</style>
